import { Card, CardContent } from "@mui/material";
import React from "react";
import { CPLogo } from "./CPLogo";

interface CPCardProps {
  showLogo?: boolean;
  children: React.ReactNode;
}

export const CPCard: React.FC<CPCardProps> = ({ 
  children, 
  showLogo = true,
}) => {
  return (
    <Card className="card cp-resp-sign-card">
      <CardContent className="card-content d-flex-column-center">
        {showLogo && <CPLogo />}
        {children}
      </CardContent>
    </Card>
  );
};